import {useAppDispatch} from '../../redux';
import * as React from 'react';
import {useEffect} from 'react';
import {Route} from '@react-navigation/native';
import {getPollDetails, setPollDetails} from '../../redux/actions/polls/details';

type ResolverProps = {route: Route<string, {pollId?: string}>; [key: string]: any};

export const PollDetailsResolver = <T extends ResolverProps>(viewComponent: React.FC<T>): React.FC<T> => {
  return function Resolver(props: T) {
    const dispatch = useAppDispatch();
    const pollId = props.route.params?.pollId;

    useEffect(() => {
      if (pollId) {
        dispatch(getPollDetails(+pollId));
      } else {
        dispatch(setPollDetails(null));
      }

      return () => {
        dispatch(setPollDetails(null));
      };
    }, [pollId]);

    return React.createElement(viewComponent, props);
  };
};
